import { render, staticRenderFns } from "./ZAssignTask.vue?vue&type=template&id=3619adbc&scoped=true"
import script from "./ZAssignTask.vue?vue&type=script&lang=js"
export * from "./ZAssignTask.vue?vue&type=script&lang=js"
import style0 from "./ZAssignTask.vue?vue&type=style&index=0&id=3619adbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3619adbc",
  null
  
)

export default component.exports